import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { Invoice } from '@acp/shared';
import { uploadInvoiceToIntegration } from '../service';

export function useInvoiceIntegrationUpload({
    onSuccess = () => {},
    onError = () => {},
}: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
} = {}) {
    const toast = useToast();

    const mutation = useMutation({
        mutationFn: async ({
            invoice,
        }: {
            invoice: Invoice;
        }) => {
            await uploadInvoiceToIntegration(invoice.id);
        },
        onSuccess: (_, { invoice }) => {
            toast({
                title: `Invoice #${invoice.invoiceNumber} started uploading`,
                description: 'This invoice will be uploaded to your property management system in the background',
                status: 'success',
                isClosable: true,
            });

            onSuccess();
        },
        onError: (error, { invoice }) => {
            toast({
                title: `Invoice #${invoice.invoiceNumber} failed to upload`,
                description: `We experienced an error while trying to upload this invoice (${error.message})`,
                status: 'error',
                isClosable: true,
            });
            onError(error);
        },
    });

    return {
        isPending: mutation.isPending,
        hasUploaded: mutation.isSuccess,
        upload: mutation.mutate,
    };
}
